import React from 'react';
import { StepProps } from '../../types/form';
import { FormField } from '../ui/FormField';
import { ToggleGroup } from '../ui/ToggleGroup';
export function GeneralSupportStep({
  formData,
  updateFormData,
  errors
}: StepProps) {
  return <div className="space-y-8" data-id="element-84">
      <div data-id="element-85">
        <h2 className="text-lg font-semibold text-foreground" data-id="element-86">General & Support</h2>
        <p className="text-sm text-muted-foreground" data-id="element-87">
          Account settings and support access for this group.
        </p>
      </div>

      <div className="space-y-4" data-id="element-88">
        <h3 className="text-sm font-semibold text-foreground uppercase tracking-wide" data-id="element-89">General</h3>

        <div className="bg-muted/30 border border-border rounded-md p-4 space-y-3" data-id="element-90">
          {[{
          key: 'skipPhoneVerification' as const,
          label: 'Skip phone verification during profile setup'
        }, {
          key: 'canUseForgotPassword' as const,
          label: 'Allow forgot password'
        }, {
          key: 'viewSubscriptionPlans' as const,
          label: 'Can view subscription plans'
        }, {
          key: 'showBillingInformation' as const,
          label: 'Show billing information'
        }].map(({
          key,
          label
        }) => <label key={key} className="flex items-center gap-3 cursor-pointer" data-id="element-91">
              <input type="checkbox" checked={formData[key]} onChange={e => updateFormData({
            [key]: e.target.checked
          })} className="h-4 w-4 rounded border-input" data-id="element-92" />
              <span className="text-sm text-foreground" data-id="element-93">{label}</span>
            </label>)}
        </div>
      </div>

      <div className="h-px bg-border" data-id="element-94" />

      <div className="space-y-4" data-id="element-95">
        <h3 className="text-sm font-semibold text-foreground uppercase tracking-wide" data-id="element-96">Support</h3>

        <FormField id="supportAccess" label="Support Access" error={errors.supportAccess} data-id="element-97">
          <ToggleGroup value={formData.supportAccess} onChange={v => updateFormData({
          supportAccess: v
        })} error={!!errors.supportAccess} data-id="element-98" />
        </FormField>

        {formData.supportAccess && <div className="space-y-4 pl-0 border-l-2 border-violet-blue/20 ml-1 pl-4" data-id="element-99">
            <FormField id="supportCategoriesInput" label="Support Categories (Optional)" hint="Comma-separated category names. Leave empty to use admin platform defaults." data-id="element-100">
              <input type="text" value={formData.supportCategoriesInput} onChange={e => updateFormData({
            supportCategoriesInput: e.target.value
          })} className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm" placeholder="e.g. Technical Issue, Document Issue, Billing/Account Issue" data-id="element-101" />
            </FormField>

            <label className="flex items-center gap-3 cursor-pointer" data-id="element-102">
              <input type="checkbox" checked={formData.onlyGroupAdminsCanSubmitTicket} onChange={e => updateFormData({
            onlyGroupAdminsCanSubmitTicket: e.target.checked
          })} className="h-4 w-4 rounded border-input" data-id="element-103" />
              <span className="text-sm text-foreground" data-id="element-104">
                Only group admins can submit a support ticket
              </span>
            </label>
          </div>}
      </div>
    </div>;
}